import { useContext } from 'react';

import CommsContext from './CommsContext';

const useComms = () => {
  const context = useContext(CommsContext);
  if (context === null) {
    throw new Error('useComms must be used within a CommsProvider');
  }
  return context;
};

export default useComms;
